export default "__VITE_ASSET__sP$$cQcr__"